import { sendPasswordResetEmail, signOut, updatePassword } from "firebase/auth"
import { auth } from "../config/firebase"

export const SignOut = async () => {
    try {
        await signOut(auth)
        window.location.reload()
    }
    catch (e) {
        console.log(e)
    }
}

export const SendResetPassword = async (email) => {
    try {
        await sendPasswordResetEmail(auth, email)
    }
    catch (e) {
        console.log(e)
    }
}

export const ChangePassword = async (pw) => {
    try {
        await updatePassword(auth.currentUser, pw)
    }
    catch (e) {
        alert(e.message)
    }
}
